// // index.tsx
// import React, { useEffect, useState } from "react";
// import { Table } from "antd";
// import { DatatableProps } from "../../data/interface";


// const Datatable: React.FC<DatatableProps> = ({ columns, dataSource, Selection }) => {
//   // const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
//   const [searchText, setSearchText] = useState<string>("");
//   const [Selections, setSelections] = useState<any>(true);
//   const [filteredDataSource, setFilteredDataSource] = useState(dataSource);
//   const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

//   // const onSelectChange = (newSelectedRowKeys: any[]) => {
//   //   setSelectedRowKeys(newSelectedRowKeys);
//   // };

//   const handleSearch = (value: string) => {
//     setSearchText(value);
//     const filteredData = dataSource.filter((record) =>
//       Object.values(record).some((field) =>
//         String(field).toLowerCase().includes(value.toLowerCase())
//       )
//     );
//     setFilteredDataSource(filteredData);
//   };

//   // const rowSelection = {
//   //   selectedRowKeys,
//   //   onChange: onSelectChange,
//   // };
//   useEffect(() => {
//     return setSelections(Selection);
//   }, [Selection])

//   const modifiedColumns = [
//     {
//       title: "Sr. No.",
//       dataIndex: "serial",
//       key: "serial",
//       render: (_: any, __: any, index: number) =>
//         (pagination.current - 1) * pagination.pageSize + index + 1,
//       width: 80,
//     },
//     ...columns,
//   ];

//   return (
//     <>

//       <div className="table-top-data">
//         <div className="row p-3">
//           <div className="col-sm-12 col-md-6">
//             <div className="dataTables_length" id="DataTables_Table_0_length">
//             </div>
//           </div>
//           <div className="col-sm-12 col-md-6">
//             <div id="DataTables_Table_0_filter" className="dataTables_filter text-end mb-0">
//               <label>
//                 {" "}
//                 <input
//                   type="search"
//                   className="form-control form-control-sm"
//                   placeholder="Search"
//                   aria-controls="DataTables_Table_0"
//                   value={searchText} onChange={(e) => handleSearch(e.target.value)}
//                 />
//               </label>
//             </div>
//           </div>
//         </div>
//       </div>

//       {!Selections ?
//         <Table
//           className="table datanew dataTable no-footer"
//           // rowSelection={rowSelection}
//           columns={modifiedColumns} 
//           rowHoverable={false}
//           dataSource={filteredDataSource}
//           pagination={{
//             locale: { items_per_page: "" },
//             nextIcon: <i className="ti ti-chevron-right" />,
//             prevIcon: <i className="ti ti-chevron-left" />,
//             defaultPageSize: 10,
//             showSizeChanger: true,
//             pageSizeOptions: ["10", "20", "30" , "50"],
//           }}
//         /> :
//         <Table
//           className="table datanew dataTable no-footer"
//           // rowSelection={rowSelection}
//           columns={modifiedColumns}
//           rowHoverable={false}
//           dataSource={filteredDataSource}
//           pagination={{
//             locale: { items_per_page: "" },
//             nextIcon: <i className="ti ti-chevron-right" />,
//             prevIcon: <i className="ti ti-chevron-left" />,
//             defaultPageSize: 10,
//             showSizeChanger: true,
//             pageSizeOptions: ["10", "20", "30" , "50"],
//             showTotal: (total, range) => `Showing ${range[0]} - ${range[1]} of ${total} entries`,
//           }}
//           onChange={(pagination) => {
//             setPagination({
//               current: pagination.current!,
//               pageSize: pagination.pageSize!,
//             });
//           }}
//         />}


//     </>
//   );
// };

// export default Datatable;


import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";

interface DatatableProps {
  columns: any[];
  dataSource: any[];
  Selection?: boolean;
}

// ===================== DRAGGABLE COLUMN HANDLER ===================== //

const makeColumnsDraggable = (
  cols: any[],
  onDragFinish: (newCols: any[]) => void
) => {
  let dragColIndex: number = -1;

  return cols.map((col, index) => ({
    ...col,
    onHeaderCell: () => ({
      draggable: true,
      onDragStart: () => {
        dragColIndex = index;
      },
      onDragOver: (e: any) => {
        e.preventDefault();
      },
      onDrop: () => {
        const newCols = [...cols];
        const moved = newCols.splice(dragColIndex, 1)[0];
        newCols.splice(index, 0, moved);
        onDragFinish(newCols);
      },
    }),
  }));
};

// ==================================================================== //

const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  Selection,
}) => {
  const [searchText, setSearchText] = useState<string>("");
  const [Selections, setSelections] = useState<any>(true);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  // COLUMN STATE
  const [columnState, setColumnState] = useState<any[]>(columns);

  const handleSearch = (value: string) => {
    setSearchText(value);
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };

  useEffect(() => {
    setSelections(Selection);
  }, [Selection]);

  // ===================== FIXED Sr No Column + Movable User Columns ===================== //
  const finalColumns = [
    {
      title: "Sr. No.",
      dataIndex: "serial",
      key: "serial",
      render: (_: any, __: any, index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 80,
    },
    ...makeColumnsDraggable(columnState, (newCols) => setColumnState(newCols)),
  ];
  // ==================================================================== //

  return (
    <>
      <div className="table-top-data">
        <div className="row p-3">
          <div className="col-sm-12 col-md-6"></div>

          <div className="col-sm-12 col-md-6">
            <div className="dataTables_filter text-end mb-0">
              <label>
                <input
                  type="search"
                  className="form-control form-control-sm"
                  placeholder="Search"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </label>
            </div>
          </div>
        </div>
      </div>

      {!Selections ? (
        <Table
          className="table datanew dataTable no-footer"
          columns={finalColumns}
          rowHoverable={false}
          dataSource={filteredDataSource}
          pagination={{
            locale: { items_per_page: "" },
            nextIcon: <i className="ti ti-chevron-right" />,
            prevIcon: <i className="ti ti-chevron-left" />,
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30", "50"],
          }}
        />
      ) : (
        <Table
          className="table datanew dataTable no-footer"
          columns={finalColumns}
          rowHoverable={false}
          dataSource={filteredDataSource}
          pagination={{
            locale: { items_per_page: "" },
            nextIcon: <i className="ti ti-chevron-right" />,
            prevIcon: <i className="ti ti-chevron-left" />,
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30", "50"],
            showTotal: (total, range) =>
              `Showing ${range[0]} - ${range[1]} of ${total} entries`,
          }}
          onChange={(pagination) => {
            setPagination({
              current: pagination.current!,
              pageSize: pagination.pageSize!,
            });
          }}
        />
      )}
    </>
  );
};

export default Datatable;
